import * as React from 'react'

import { Button } from '~/atoms/button/Button'

import SaveIcon from './save.svg?reactCompornt'
import * as Style from './style.css'

export interface IProps {
  cancelHandler: () => void
  clickTmpSaveHandler: () => void
}

export const FormFooterAction = ({
  cancelHandler,
  clickTmpSaveHandler,
}: IProps): JSX.Element => (
  <div className={Style.FormFooterAction}>
    <a className={Style.FormFooterTmpSave} onClick={clickTmpSaveHandler}>
      <SaveIcon />
      <span>一時保存</span>
    </a>
    <ul className={Style.FormFooterActions}>
      <li>
        <Button color="secondary" type="button" onClick={cancelHandler}>
          前の画面
        </Button>
      </li>
      <li className={Style.FormFooterActionSubmit}>
        <Button color="primary" type="submit">
          保存して次へ進む
        </Button>
      </li>
    </ul>
  </div>
)
